import React, { useContext, useState } from 'react';
import { useRouter } from 'next/router';

import { ThemeContext } from 'components/publicWebsiteV2/context';
import { publishWebsite } from 'components/publicWebsiteV2/api/client/publicWebsiteSSRApiHelpers';
import { Container, VisibleLink, ContentContainer } from './HiddenWebsiteBanner.styles';

const HiddenWebsiteBanner = (): JSX.Element | null => {
  const router = useRouter();
  const { preview_type } = router?.query || {}; // if preview_type exists, hide banner
  const { wedding, inPreview } = useContext(ThemeContext);

  const [published, setPublished] = useState(wedding?.wedding_published);

  if (wedding?.wedding_published || preview_type || inPreview) return null;

  const onPublishWebsite = () => {
    publishWebsite().then(() => setPublished(true));
  };

  return (
    <Container height={published ? 0 : 96}>
      <ContentContainer>
        Your website is currently hidden, and is not visible to guests.{' '}
        <VisibleLink onClick={onPublishWebsite}>Make it visible</VisibleLink>
      </ContentContainer>
    </Container>
  );
};

export default HiddenWebsiteBanner;
